import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { API_URL } from '../../config';
import { User } from '../../types/admin';
import SiteLayout from '../../layouts/SiteLayout';
import Header from '../../components/Header/Header';

const AdminUsersDetails: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const { token } = useAuth();
    const isNew = !id || id === 'new';

    const [formData, setFormData] = useState({
        email: '',
        full_name: '',
        role_id: 0,
        tenant_id: 0,
        password: '',
        is_active: true
    });
    const [loading, setLoading] = useState(false);
    const [roles, setRoles] = useState<any[]>([]);
    const [tenants, setTenants] = useState<any[]>([]);

    useEffect(() => {
        // Mock data loading - replace with actual API calls
        const loadData = async () => {
            setLoading(true);
            try {
                // Mock Roles
                setRoles([
                    { id: 1, name: 'global_admin' },
                    { id: 2, name: 'admin_platform' },
                    { id: 3, name: 'support_user' },
                    { id: 4, name: 'basic_user' },
                ]);

                // Mock Tenants
                setTenants([
                    { id: 1, name: 'Default' },
                    { id: 2, name: 'Premium Corp' },
                ]);

                if (!isNew) {
                    // Fetch user details (In progress)
                    /*
                    const response = await fetch(`${API_URL}/v1/admin/users/${id}`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    const data = await response.json();
                    setFormData(data.data);
                    */

                    // Mock user data for now
                    console.log("Fetching user", id);
                    setFormData({
                        email: 'user@example.com',
                        full_name: 'John Doe',
                        role_id: 4,
                        tenant_id: 1,
                        password: '',
                        is_active: true
                    });
                }
            } catch (error) {
                console.error("Error loading data:", error);
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [id, isNew, token]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        try {
            console.log("Saving user:", formData);
            // TODO: Implement API call
            // await fetch(`${API_URL}/v1/admin/users${isNew ? '' : `/${id}`}`, { method: isNew ? 'POST' : 'PUT', ... });

            setTimeout(() => {
                alert("User saved successfully (Mock)");
                navigate('/admin/users');
            }, 1000);
        } catch (error) {
            console.error("Error saving user:", error);
            alert("Error saving user");
        } finally {
            setLoading(false);
        }
    };

    return (
        <SiteLayout>
            <Header icon='person' title={isNew ? 'Nouvel Utilisateur' : 'Modifier Utilisateur'} />
            <div style={{ marginBottom: '20px' }}>
                <button className="btn btn-secondary" onClick={() => navigate('/admin/users')} style={{ marginBottom: '10px' }}>
                    <i className="material-icons" style={{ verticalAlign: 'middle' }}>arrow_back</i> Retour
                </button>
                <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b' }}>
                    {isNew ? 'Nouvel Utilisateur' : 'Modifier Utilisateur'}
                </h2>
            </div>

            <div className="box" style={{ padding: '30px' }}>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label">Nom Complet</label>
                        <input
                            type="text"
                            name="full_name"
                            className="form-input"
                            value={formData.full_name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">Email</label>
                        <input
                            type="email"
                            name="email"
                            className="form-input"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            disabled={!isNew} // Usually email is immutable or requires special process
                        />
                    </div>

                    {!isNew && (
                        <div className="form-group">
                            <label className="form-label">Nouveau Mot de passe (Laisser vide pour ne pas changer)</label>
                            <input
                                type="password"
                                name="password"
                                className="form-input"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="********"
                            />
                        </div>
                    )}

                    <div className="form-group">
                        <label className="form-label">Rôle</label>
                        <select
                            name="role_id"
                            className="form-select"
                            value={formData.role_id}
                            onChange={handleChange}
                        >
                            <option value={0}>Sélectionner un rôle</option>
                            {roles.map(role => (
                                <option key={role.id} value={role.id}>{role.name}</option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label className="form-label">Tenant</label>
                        <select
                            name="tenant_id"
                            className="form-select"
                            value={formData.tenant_id}
                            onChange={handleChange}
                        >
                            <option value={0}>Aucun Tenant</option>
                            {tenants.map(tenant => (
                                <option key={tenant.id} value={tenant.id}>{tenant.name}</option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <label className="switch">
                            <input
                                type="checkbox"
                                name="is_active"
                                checked={formData.is_active}
                                onChange={handleChange}
                            />
                            <span className="slider round"></span>
                        </label>
                        <span>Compte Actif</span>
                    </div>

                    <div style={{ marginTop: '30px', display: 'flex', gap: '10px' }}>
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Enregistrement...' : 'Enregistrer'}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={() => navigate('/admin/users')}>
                            Annuler
                        </button>
                    </div>
                </form>
            </div>
        </SiteLayout>
    );
};

export default AdminUsersDetails;
